module.exports = __webpack_public_path__ + "img/ToyFaces_Colored_BG_10.d6c63278.jpg";